import * as yup from 'yup';

export const connectionValidationSchema = yup.object().shape({
  senderCompanyId: yup.string().nullable(),
  receiverTreadId: yup.string().required(),
  accountTypes: yup.array().of(yup.string()).min(1),
});
